export const TIMESPAN = {
  // TimespanResources.tsx
  CONTAINER: 'timespan-container',
  MAIN_NAV_LEFT_ELEMENTS: 'timespan-main-nav-left-elements',
  MAIN_NAV_MIDDLE_ELEMENTS: 'timespan-main-nav-middle-elements',
  MAIN_NAV_RIGHT_ELEMENTS: 'timespan-main-nav-right-elements',
  MORE_MENU_BUTTON: 'timespan-more-menu-button',
  RUN_CPM_BUTTON: 'timespan-run-cpm-button',
  READ_ONLY_BUTTON: 'timespan-read-only-button',
  COMMENT_ONLY_BUTTON: 'timespan-comment-only-button',
  CONTENT_WRAPPER: 'timespan-content-wrapper',
  PAGE_TITLE: 'timespan-page-title',
  TAB_WRAPPER: 'timespan-tab-wrapper',
  TABS_WRAPPER: 'timespan-tabs-wrapper',
  RESOURCE_LIST_TAB: 'timespan-resource-list-tab',
  LABOR_OUTPUT_TAB: 'timespan-labor-output-tab',
  EQUIPMENT_OUTPUT_TAB: 'timespan-equipment-output-tab',
  TAB_CONTENTS: 'timespan-tab-contents',
  RESOURCE_LIST_PANEL: 'timespan-resource-list-panel',
  LABOR_OUTPUT_PANEL: 'timespan-labor-output-panel',
  EQUIPMENT_OUTPUT_PANEL: 'timespan-equipment-output-panel',
  EMPTY_STATE: 'timespan-empty-state',

  // LazyTimespanResources.tsx
  LAZY_SUSPENSE: 'timespan-lazy-suspense',

  // AddTimespanResourcesDialog.tsx
  DIALOG: 'timespan-dialog',
  DIALOG_CLOSE_BUTTON: 'timespan-dialog-close-button',
  DIALOG_CLOSE_ICON: 'timespan-dialog-close-icon',
  DIALOG_TITLE: 'timespan-dialog-title',
  DIALOG_CONTENT: 'timespan-dialog-content',
  DIALOG_CONTENT_WRAPPER: 'timespan-dialog-content-wrapper',
  STEPS_NAV: 'timespan-steps-nav',
  STEP_NAV_MAIN: 'timespan-step-nav-main',
  STEP_NAV_START_ON: 'timespan-step-nav-start-on',
  STEP_NAV_FINISH_ON: 'timespan-step-nav-finish-on',
  STEP_NUMBER: 'timespan-step-number',
  STEP_TEXT: 'timespan-step-text',
  INPUT_SECTION: 'timespan-input-section',
  INPUT_LABEL: 'timespan-input-label',
  INPUT_FIELD: 'timespan-input-field',
  NAME_INPUT: 'timespan-name-input',
  LABOR_FIELD: 'timespan-labor-field',
  LABOR_PILLS_WRAPPER: 'timespan-labor-pills-wrapper',
  LABOR_PLACEHOLDER: 'timespan-labor-placeholder',
  LABOR_ADD_ICON: 'timespan-labor-add-icon',
  EQUIPMENT_FIELD: 'timespan-equipment-field',
  EQUIPMENT_PILLS_WRAPPER: 'timespan-equipment-pills-wrapper',
  EQUIPMENT_PLACEHOLDER: 'timespan-equipment-placeholder',
  EQUIPMENT_ADD_ICON: 'timespan-equipment-add-icon',
  CALENDAR_FIELD: 'timespan-calendar-field',
  CALENDAR_PICKER: 'timespan-calendar-picker',
  DIALOG_ACTIONS: 'timespan-dialog-actions',
  LEFT_ACTIONS: 'timespan-left-actions',
  RIGHT_ACTIONS: 'timespan-right-actions',
  FINISH_LATER_BUTTON: 'timespan-finish-later-button',
  PREVIOUS_BUTTON: 'timespan-previous-button',
  NEXT_BUTTON: 'timespan-next-button',
  FINISH_BUTTON: 'timespan-finish-button',

  // TimespanResourcesList.tsx
  ADD_BUTTON: 'timespan-add-button',
  WARNING_MESSAGES: 'timespan-warning-messages',
  NEGATIVE_DURATION_MESSAGE: 'timespan-negative-duration-message',
  EMPTY_FIELDS_MESSAGE: 'timespan-empty-fields-message',
  RESOURCES_GRID: 'timespan-resources-grid',
  LIST_WRAPPER: 'timespan-list-wrapper',
  LIST: 'timespan-list',
  AG_GRID: 'timespan-ag-grid',

  // TimespanUsage.tsx
  USAGE_CONTENT_WRAPPER: 'timespan-usage-content-wrapper',
  USAGE_WARNING_MESSAGES: 'timespan-usage-warning-messages',
  USAGE_WARNING_ICON: 'timespan-usage-warning-icon',
  USAGE_WARNING_MESSAGE: 'timespan-usage-warning-message',
  INFO_CARDS_WRAPPER: 'timespan-info-cards-wrapper',
  RESOURCE_CHARTS: 'timespan-resource-charts',
  GRID_CTAS: 'timespan-grid-ctas',
  GRID_CTAS_TEXT: 'timespan-grid-ctas-text',
  DOWNLOAD_EXCEL_BUTTON: 'timespan-download-excel-button',
  DOWNLOAD_EXCEL_ICON: 'timespan-download-excel-icon',
  DOWNLOAD_EXCEL_TEXT: 'timespan-download-excel-text',
  RESOURCE_USAGE_GRID: 'timespan-resource-usage-grid',
  NO_RESOURCE_STATE: 'timespan-no-resource-state',
  ADD_RESOURCE_BUTTON: 'timespan-add-resource-button',
  LOADING: 'timespan-loading',

  // Start/End Widget Components
  WIDGET_CONTAINER: 'timespan-widget-container',
  TAB_SECTION: 'timespan-tab-section',
  SELECT_ACTIVITY_TAB: 'timespan-select-activity-tab',
  SELECT_DATE_TAB: 'timespan-select-date-tab',
  ACTIVITY_SECTION: 'timespan-activity-section',
  COMBO_SEARCH_BUTTON: 'timespan-combo-search-button',
  COMBO_SEARCH_BOX: 'timespan-combo-search-box',
  SELECTED_ELEMENT_DISPLAY: 'timespan-selected-element-display',
  LAG_INPUT: 'timespan-lag-input',
  DATE_SECTION: 'timespan-date-section',
  DATE_PICKER: 'timespan-date-picker',
  DATE_PICKER_BUTTON: 'timespan-date-picker-button'
} as const;
